"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appSectionNavigationItem = void 0;
var lodash_1 = require("lodash");
var appSectionNavigationItem = function (_a) {
  var appSection = _a.appSection,
    appSectionChild = _a.appSectionChild,
    icons = _a.icons,
    t = _a.t,
    entities = _a.entities;
  var appSectionIcons = icons.AppSections;
  var appSectionIcon = appSectionIcons[appSection.label];
  if (!appSectionChild) {
    // return an item for the entire section
    return {
      to: "/".concat(appSection.path),
      label: t(appSection.label || ''),
      icon: appSection.icon || function () {
        return appSectionIcons[appSection.label] || icons.Feed;
      }
    };
  }
  var item = {
    to: "/".concat(appSection.path, "/").concat(appSectionChild.path),
    label: t(appSectionChild.label || appSection.label || ''),
    icon: appSectionChild.icon || function (_a) {
      var icons = _a.icons;
      return appSectionIcons[appSectionChild.label] || appSectionIcons[appSection.label];
    },
    // todo, make this better
    divider: !!appSectionChild.divider
  };
  if ((0, lodash_1.includes)(['list', 'list-expandable'], appSectionChild.type)) {
    var entityDefinition_1 = entities[appSectionChild.entityTypeName];
    if (!entityDefinition_1) {
      throw new Error("Cannot find entity definition for item ".concat(appSectionChild.label));
    }
    item.to = entityDefinition_1.toList();
    item.label = t(entityDefinition_1.pluralLabel);
    item.icon = entityDefinition_1 && function (_a) {
      var icons = _a.icons;
      return icons.Entities[entityDefinition_1.name];
    };
  }
  if (appSectionChild.type === 'feed') {
    item.to = "/".concat((0, lodash_1.filter)([appSection.path, appSectionChild.path]).join('/'));
    item.label = t(appSection.label);
    item.icon = appSectionChild.icon || function (_a) {
      var icons = _a.icons;
      return appSectionIcon || icons.Feed;
    };
  }
  return item;
};
exports.appSectionNavigationItem = appSectionNavigationItem;